// release-recipe-run-inputs.ts
//
// How a configured release recipe becomes the input of a run — split out of
// supervisor-release-approved-g3-leg.ts (200-line budget; a pure move).
import type { DeployOperationInput } from "./deployment-adapter.js";
import { resolveRecipeCwdAgainstRepoRoot } from "./recipe-cwd-resolved-against-repo-root.js";
import type { ReleaseConfig } from "./release-manifest-hash.js";
import { DEFAULT_RELEASE_RECIPE_TIMEOUT_SEC } from "./schemas/release-recipe-schema.js";

/** A4: per-recipe cap from config.release (seconds), absent ⇒ the beta default. */
export function recipeTimeoutMs(configuredSec: number | undefined): number {
  return (configuredSec ?? DEFAULT_RELEASE_RECIPE_TIMEOUT_SEC) * 1000;
}

// Dogfood Beta 9 (F1/F2): release recipes used to get `env: {}` (so
// `env_allowlist` forwarded nothing — `node` was ENOENT) and the raw `cwd`.
// They now run exactly like a ticket's verification recipe: cwd resolved
// against the mission worktree, env = this process's env filtered by the
// recipe's allowlist (verification-recipe-runner.ts). The G3/deploy hashes
// still bind the recipe AS CONFIGURED (release-manifest-hash.ts).
export function deployInput(
  release: ReleaseConfig,
  repoDir: string,
): Omit<DeployOperationInput, "store"> | undefined {
  if (release.deploy_recipe === undefined) return undefined;
  return {
    recipe: resolveRecipeCwdAgainstRepoRoot(release.deploy_recipe, repoDir),
    env: process.env,
    timeoutMs: recipeTimeoutMs(release.deploy_timeout_sec),
    operationKind: "deploy",
    nonIdempotent: false,
  };
}
